import s from "./ToggableButton.module.scss";
import React from "react";
import cn from "classnames";

interface IProps {
  onPress: () => void;
}

export const PlusButton = ({ onPress }: IProps) => {
  return (
    <div
      data-cy="ToggableButtonAdd"
      onClick={() => onPress()}
      className={cn(s.itemContainer, s.plus)}
    >
      <span className={s.legendItemName}>+</span>
    </div>
  );
};

export default PlusButton;
